import React, { useState } from "react";
import { LegacyCard as Card, InlineStack, BlockStack, Collapsible, Text } from "@shopify/polaris";

import { reviewVariant } from "app/productOld/modules/operator/features/review/props";

const ReviewVariant = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    isAdded,
    isDeleted,
    date,
    vendor,
    vendorChange,
    sellerChange,
    store,
    sellerLabel,
    // changedKey: key,
    // onToggleSelect,
    // isVariantIdAvailable,
    cms,
  } = props;

  const actionText = (isAdded && "Added") || (isDeleted && "Deleted") || "Updated";
  // const [isSelected, setIsSelected] = useState(true);
  // const handleToggleSelect = () => {
  //   setIsSelected(!isSelected);
  //   onToggleSelect(key);
  // };
  return (
    <Card
      sectioned
      title={[
        // <Checkbox
        //   label="Basic checkbox"
        //   labelHidden
        //   disabled={!isVariantIdAvailable}
        //   checked={isSelected}
        //   onChange={handleToggleSelect}
        // />,
        // " ",
        `${sellerLabel}`,
      ]}
      actions={[
        {
          content: isOpen ? cms("common.label.hide") : cms("common.label.show"),
          onAction: () => setIsOpen(!isOpen),
          disclosure: isOpen ? "up" : "down",
        },
      ]}
    >
      <InlineStack>
        <Text variant="bodySm" as="p">
          {`${cms("common.label.lastUpdatedAt")}: `}
          {date}
        </Text>
      </InlineStack>
      <BlockStack>
        <Collapsible open={isOpen} id="basic-collapsible-2">
          <Card.Section title={`${actionText} by ${vendor}`}>{vendorChange}</Card.Section>
          <Card.Section subdued title={`Published at ${store}`}>
            {sellerChange}
          </Card.Section>
        </Collapsible>
      </BlockStack>
    </Card>
  );
};

ReviewVariant.propTypes = reviewVariant.type;

export default ReviewVariant;
